module.exports = __webpack_public_path__ + "static/media/TransactionArrow.d4e59442.svg";